let reviewsModal = document.querySelector(".reviews_modal");
let reviewBtns = document.querySelectorAll(".write_review");
let reviewsWrapper = document.querySelector(
  ".collection__title .review-wrapper"
);
let reviewsModalInput = document.querySelector("#reviewsModalInput");
console.log("reviewBtns: ", reviewBtns);
console.log({ reviewsWrapper });
if (reviewsModal) {
  const ratingSnippet = reviewsWrapper.querySelector(".ruk_rating_snippet");
  if (ratingSnippet) {
    ratingSnippet.style.pointerEvents = "none";
  }
  reviewsWrapper.addEventListener("click", (e) => {
    reviewsModalInput.checked = true;
  });
  const writeReviewBtn = reviewsWrapper.querySelector(".write_review");
  if (writeReviewBtn) {
    writeReviewBtn.addEventListener("click", (e) => {
      reviewsModalInput.checked = true;
    });
  }
} else {
  if (reviewBtns) {
    reviewBtns.forEach((reviewBtn) => {
      reviewBtn.addEventListener("click", (e) => {
        document.querySelector(".ruk-rating-snippet-count").click();
        setTimeout(() => {
          document.querySelector("#reviews_fade .R-Button").click();
        }, 450);
      });
    });
  }
}
